import { render, staticRenderFns } from "./SimpleSpinner.vue?vue&type=template&id=550112c1&scoped=true&"
import script from "./SimpleSpinner.vue?vue&type=script&lang=js&"
export * from "./SimpleSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550112c1",
  null
  
)

export default component.exports